export default __webpack_public_path__ + "static/media/restaurant.92e98af4.png";